import "./pages.styl";
import {getSupaPageList, getSupaACL} from "../_resources/supa-helpers.js";
import PagesStatusSectionView from "./PagesStatusSectionView.js";
import PagesOnepageSectionView from "./PagesOnepageSectionView.js";
import { sidebarCollapseController } from "../_resources/ui-library.js";
import FilePickerView from "./FilePickerView.js";

const SELECTED_PAGE = 'admin.servers.selected_page_id';

function getSelectedPage(pageList){
  // Only use localStorage for selected page
  const localPageId = localStorage.getItem(SELECTED_PAGE);
  const selectedPage = pageList.find(s => "page-" + s.id === localPageId);
  return selectedPage || pageList[0];
}


export default function PagesView({ dom, message, getToken, getUserId }){
  const {bad, info, progress, good} = message;
  const container = d3.select(dom);

  const filePickerView = new FilePickerView({ message });
  const pageStatusSection = new PagesStatusSectionView({ 
    dom: container.select(".statusSection"), 
    message, 
    refresh: () => render(true), 
    getToken, 
    getUserId
  });
  const onePageSection = new PagesOnepageSectionView({ 
    dom: container.select(".contentSection"), 
    sidebar: container.select(".admin-sidebar"), 
    message, 
    refresh: () => render(true), 
    getToken, 
    getUserId,
    filePicker: filePickerView 
  });

  sidebarCollapseController(dom);

  async function render(refresh = false) {

    const {ok: supaACL, error: e1} = await getSupaACL(refresh);
    const {ok: pageList, error: e2} = await getSupaPageList(refresh);
    if (e1 || e2) return bad(e1 || e2); //❌
    const selectedPage = getSelectedPage(pageList);
    pageStatusSection.render(pageList, onClickCard, selectedPage);

    for await (const page of pageList){
      pageStatusSection.updateCard(page, selectedPage.id, getToken, getUserId);
    }

    await onClickCard(selectedPage, refresh); 
    
    // Backfill URL with subtab if not present (will be set by onePageSection.render)
  }

  async function onClickCard(selectedPage, refresh = false) {
    const pageKey = "page-" + selectedPage.id;
    if (pageKey !== localStorage.getItem(SELECTED_PAGE)) {
      localStorage.setItem(SELECTED_PAGE, pageKey);
    }
    onePageSection.render(selectedPage, refresh);
  }

  return { render };
}
